export function handleAnswer(arrList) {
  const answerList = arrList || JSON.parse(localStorage.getItem('testInfo'));
  const answer = [];
  answerList.map(item => {
    if (item.type === 2 || item.type === 8 || item.type === 18 || item.type === 19) {
      var score = 0
      if ((item.app_id == 82 || item.app_id == 60 || item.app_id == 61 || item.app_id == 62) && item.type === 8) {
        // const answerOp = item.answer.split('');
        const answerOp = item.answer.replace(/,/g, '').replace(/，/g, '').split('');
        const errorNum = compare(item.value, answerOp, true);// 计算错误个数
        // const errorNum = compare(answerOp, item.value, true).length;// 计算错误个数
        // console.log(errorNum,'计算错误个数')
        if (answerOp.length - errorNum > 0) {
          score = ((answerOp.length - errorNum) / answerOp.length) * item.score
        } else {
          score = 0
        }
        // console.log(score,'分数分数')
      } else {
        const answerOp = item.answer.replace(/,/g, '').replace(/，/g, '').split('');
        // const answerOp = item.answer.split('');
        const rightNum = compare(answerOp, item.value);// 计算正确个数
        if (rightNum.length === answerOp.length && answerOp.length === item.value.length) {
          // 正确
          score = item.score
        } else {
          score = 0
        }
      }
      // 多选
      answer.push({
        answer: item.value.sort().join(''),
        question_id: item.id,
        // is_right: compare(item.answer.split(''), item.value).length === item.answer.split('').length && item.answer.split('').length === item.value.length ? 1 : 0,
        is_right: compare(item.answer.replace(/,/g, '').replace(/，/g, '').split(''), item.value).length === item.answer.replace(/,/g, '').replace(/，/g, '').split('').length && item.answer.replace(/,/g, '').replace(/，/g, '').split('').length === item.value.length ? 1 : 0,
        remarks: !!item.remarks,
        score: score > 0 ? score.toFixed(1) : 0,
        newAnswerOptions: item.option && item.option.length > 0 ? item.option.map(item => item.key).join('') : ""
        // newAnswerOptions: JSON.stringify(item.option)
      })
    } else {
      // 单选
      answer.push({
        answer: item.value,
        question_id: item.id,
        is_right: item.value === item.answer ? 1 : 0,
        remarks: !!item.remarks,
        score: item.value == item.answer ? item.score : 0,
        newAnswerOptions: item.option && item.option.length > 0 ? item.option.map(item => item.key).join('') : ''
        // newAnswerOptions: JSON.stringify(item.option)
      })
    }
  })
  return answer;
}
export function handleScore(data) {
  const answerArr = JSON.parse(localStorage.getItem('testInfo')).filter(item => item.value.length !== 0);
  let total = 0;
  answerArr.map(item => {
    if (item.type === 2 || item.type === 8 || item.type === 18 || item.type === 19) {
      // if (item.app_id == 82 || item.app_id == 60) {
      if ((item.app_id == 82 || item.app_id == 60 || item.app_id == 61 || item.app_id == 62) && item.type === 8) {
        // const answerOp = item.answer.split('');
        const answerOp = item.answer.replace(/,/g, '').replace(/，/g, '').split('');
        // const errorNum = compare(answerOp, item.value, true).length;// 计算错误个数
        const errorNum = compare(item.value, answerOp, true);// 计算错误个数
        if (answerOp.length - errorNum > 0) {
          const score = ((answerOp.length - errorNum) / answerOp.length) * item.score
          total += score
        } else {
          total += 0
        }
      } else {
        // const answerOp = item.answer.split('');
        const answerOp = item.answer.replace(/,/g, '').replace(/，/g, '').split('');
        const rightNum = compare(answerOp, item.value);// 计算正确个数
        if (rightNum.length === answerOp.length && answerOp.length === item.value.length) {
          // 正确
          total += item.score
        } else {
          total += 0
        }
      }
    } else {
      if (item.value == item.answer) {
        total += item.score
      }
    }
  })
  return total
}
function compare(arr1, arr2, type) {
  if (type) {
    // 计算错误个数
    // if (arr1.length >= arr2.length) {
    //   const result = arr1.filter(element => !arr2.includes(element));
    //   return result
    // } else {
    //   const commonElements = arr1.filter(element => arr2.includes(element));
    //   const difference = arr2.filter(element => !commonElements.includes(element));
    //   return difference
    // }
    // 将字符串转换为集合
    // 如果答案1为空，则错误个数为正确答案的长度
    // 如果答案1为空，则错误个数为正确答案的长度
    if (arr1.length === 0) {
      return arr2.length;
    }
    // 将数组转换为集合
    const setAnswer1 = new Set(arr1);
    const setCorrectAnswer = new Set(arr2);
    // 计算交集
    const intersection = new Set([...setAnswer1].filter(x => setCorrectAnswer.has(x)));
    // 计算错误个数
    const errors = (setAnswer1.size - intersection.size) + (setCorrectAnswer.size - intersection.size);
    return errors;
  } else {
    // 计算正确个数
    return arr1.filter((v) => {
      return arr2.includes(v);
    });
  }
}
// 全屏
export function fullScreen() {
  const element = document.documentElement;
  if (element.requestFullscreen) {
    return element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    return element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    return element.webkitRequestFullscreen();
  } else if (element.webkitRequestFullScreen) {
    return element.webkitRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    return element.msRequestFullscreen();
  }
  return Promise.resolve();
}
// 取消全屏
export function turnFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}
// 是否全屏
export function isFullscreenActive() {
  return !!(
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.webkitCurrentFullScreenElement ||
    document.webkitIsFullScreen
  )
}

// 处理试卷题目
export function testData(data) {

}
